module.exports = __webpack_public_path__ + "img/eplato_logo.ba70f9b8.png";